import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import '../App.css';
import Amplify, {Auth} from 'aws-amplify';
import AWS from 'aws-sdk'
import API_GATEWAY from "./hostname";
import S3_FW_BUCKET_NAME from "./s3bucketname";
import loadimg from "../images/loading.gif";
import { Storage } from 'aws-amplify';

AWS.config.update({
    accessKeyId: 'AKIAR7ANV7GJZZ2WZVAA',
    secretAccessKey: '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'
})

const myBucket = new AWS.S3({
    params: { Bucket: S3_FW_BUCKET_NAME},
    region: 'ap-northeast-1'
})

const getIdToken = () =>{
    return new Promise((resolve, reject) => {
        try{
            Auth.currentSession().then((data) => {
                return resolve(data.getIdToken().getJwtToken());
              });
        }
        catch(e){
            console.log('Not signed in');
            return reject('ID取得失敗')
        }  
    })
}

const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
async function getControlResults(token, control_id){
    // すぐに状態取得しないように1秒待つ
    var count = 0;
    var controlResult = "";
    var isSuccess = false;
    while(count < 10){
        await _sleep(1000)
        const statusUrl = API_GATEWAY + "/console/v1/devices/control-results/"+ control_id;
        const resultHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization':token
        };
        const resultMethod = "GET"
        await fetch(statusUrl,{method:resultMethod, headers:resultHeaders, mode:"cors"})
        .then((res)=> res.json())
        .then(data => {
            if(data["status"] == "success"){
                controlResult = data["status"];
                isSuccess = true;
            }else{
                controlResult = data["status"];
            }
        },[])
        .catch(err => {
            controlResult = err;
            })
        if(isSuccess){
            return controlResult;
        }
        count++;
    }
    
    return controlResult;
    
}

function Setting_gateway() {
    const [registSend, setRegistSend] = useState(0);
    const isFirstRenderRegist = useRef(false)
    const location = useLocation();
    const [gatewayInfo, setGatewayInfo] = useState({});
    const [admFlag, setAdmFlag] = useState(false);
    const history = useHistory();
    const [gwSerialNumber, setGwSerialNumber] = useState('');
    const [loading, setLoading] = useState(true);
    const [hotelName, setHotelName] = useState('');

    useEffect(() => {
        isFirstRenderRegist.current = true
        isAdmin();

        if(location.state){
            setGwSerialNumber(location.state.gwSerialNumber);
            setHotelName(location.state.hotelName);
        }
        else{
            history.push({
                pathname: "/",
            });
        }

        updateGwInfo();
    },[]);
    const [placeName, setPlaceName] = useState('')
    const [oldPlaceName, setOldPlaceName] = useState('')
    const roomHandleChange = (e) => {
        setPlaceName(() => e.target.value)
    }
    const [floorName, setFloorName] = useState('')
    const [oldFloorName, setOldFloorName] = useState('')
    const floorHandleChange = (e) => {
        setFloorName(() => e.target.value)
    }
    const [fwVersion, setFwVersion] = useState('')
    const [gwState, setGwState] = useState('正常')
    const getGwInfo = () =>{
        return new Promise((resolve, reject) => {
            try{
                getIdToken()
                .then(result => {
                    const method = "GET";
                    const headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':result
                      };
                    var url = API_GATEWAY + "/console/v1/devices/gws/"+location.state.gwID;
                    fetch(url,
                    {method:method, headers:headers})
                    .then((res)=> res.json())
                      .then(data => {
                        console.log("GW情報取得のfetch実行完了")
                        return resolve(data);
                      },[])
                      .catch(err => {
                        console.log("GW情報取得のfetch失敗")
                        alert("GW情報の取得に失敗しました")
                        return reject('GW情報取得失敗')
                        })
                }).catch(error => {
                    console.error("IDトークン取得失敗")
                    return reject('IDトークン取得失敗')
                })
            }
            catch(e){
                console.log('GW情報取得失敗');
                return reject('GW情報取得失敗')
            }  
        })
    }

    // 登録ボタンを押すたびに呼ばれる
    useEffect(()=>{
        if(isFirstRenderRegist.current){
            isFirstRenderRegist.current = false;
        }
        else{
            var sendFloorName = floorName;
            var sendPlaceName = placeName;
            if(!placeName){
                // 設置部屋番号が空白の場合は半角スペースを入れて見た目上空白にする
                setPlaceName(" ");
                // placeNameにスペースをセットしてもこの時点では反映されていないためsendPlaceNameにも入れておく
                sendPlaceName = " ";
            }
            var isInvalid = getIsInvalid(sendFloorName, sendPlaceName);
            if(isInvalid){
                alert(isInvalid)
            }
            else{
                getIdToken()
                .then(result => {
                    const obj = {
                        "floor": sendFloorName,
                        "name": sendPlaceName
                        };
                    const method = "PUT";
                    const body = JSON.stringify(obj);
                    const headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':result
                    };
                    const gwInfoUpdateUrl = API_GATEWAY + "/console/v1/devices/gw-info/"+location.state.gwID;
                    fetch(gwInfoUpdateUrl,
                    {method:method, headers:headers, body:body, mode:"cors"})
                    .then(res=> {
                        console.log("fetch実行完了:")
                        alert("GW情報変更が成功しました。")
                        window.location.reload();
                    },[])
                    .catch(err => {
                    alert("GW情報取得に失敗しました")
                    })
                }).catch(error => {
                    console.error("IDトークン取得失敗")
                })
            }
            
        }
    },[registSend])

    async function isAdmin(){
        try{
            const user = await Auth.currentUserPoolUser();
            const attrs = await Auth.userAttributes(user);
            attrs.forEach(function(attr){
                if (attr.Name == 'custom:authority' &&
                    (attr.Value == 'admin' || attr.Value == 'installation')){
                    setAdmFlag(true);
                }
            });
        }
        catch(e){
            Auth.signOut();
        }
    }
    function updateGwInfo(){
        getGwInfo()
                .then(result => {
                    const nowdate = new Date();
                    const info = {
                        serial_number: result.serial_number,
                        last_keepalive_time: nowdate.toLocaleString()
                    };
                    setGatewayInfo(info);
                    // 備考がスペースのみの時は削除する
                    if(result.name == " "){
                        setPlaceName("");
                        setOldPlaceName("");
                    }
                    else{
                        setPlaceName(result.name);
                        setOldPlaceName(result.name);
                    }
                    setFloorName(result.floor);
                    setOldFloorName(result.floor);
                    setFwVersion(result.fw_ver);
                    const gwdate = new Date(result.last_keepalive_time);
                    if (nowdate.getTime() - gwdate.getTime() > 5 * 60 * 1000){
                        setGwState("ネットワーク切断 (" + result.last_keepalive_time + ")");
                    }else{
                        console.log("within 5 min")
                    }
                    setLoading(false)
                }).catch(error => {
                    console.error("GW情報失敗")
                    setLoading(false)
                })
    }

    const getS3_preurl = () =>{
        return new Promise((resolve, reject) => {
            try{
                myBucket.listObjectsV2({
                    Bucket: S3_FW_BUCKET_NAME,
                    Prefix: location.state.hotelID
                }).promise().then(result => {
                    // ファイルリスト取得成功
                    var fw_file = {"binURL":"", "md5URL":""};
                    if(result && result.Contents){
                        for(var i = 0; i < result.Contents.length; i++){
                            const name = "http://" + S3_FW_BUCKET_NAME + ".s3.ap-northeast-1.amazonaws.com/" + result.Contents[i].Key;
                            if(result.Contents[i].Key.slice(-4) == ".bin"){
                                fw_file["binURL"] = name;
                            }
                            else if(result.Contents[i].Key.slice(-4) == ".md5"){
                                fw_file["md5URL"] = name;
                            }
                        }
                    }
                    return resolve(fw_file);
                }).catch(err => {
                    // ファイルリスト取得失敗
                    console.log("ファイルリストの取得に失敗しました");
                });
            }
            catch(e){
                console.log('fwファイル取得失敗');
                return reject('fwファイル取得失敗')
            }
        })
    }

    function handleFwClick(e: React.MouseEvent){
        e.preventDefault(); // フォーム送信を抑止

        getIdToken()
        .then(result => {
            var token = result;
            getS3_preurl().then(result => {
                const binURL = result["binURL"];
                const md5URL = result["md5URL"];
                const obj = {
                    "download_url": binURL,
                    "checksum_url": md5URL
                    };
                const method = "PUT";
                const body = JSON.stringify(obj);
                const headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':token
                };
                const gwInfoUpdateUrl = API_GATEWAY + "/console/v1/devices/gws/"+location.state.gwID+"/fw-update";
                fetch(gwInfoUpdateUrl,
                {method:method, headers:headers, body:body})
                .then((res)=> {
                    console.log("fw更新実行完了")
                    alert("ファームウェアを更新しました")
                },[])
                .catch(err => {
                    alert("ファームウェア更新に失敗しました")
                })

            }).catch(err => {
                // preURL取得失敗
                console.log("URLの取得に失敗しました");
            });

        }).catch(error => {
            console.error("IDトークン取得失敗")
        });


    }
    function handleExclusionClick(e: React.MouseEvent){
        e.preventDefault(); // フォーム送信を抑止
        getIdToken()
        .then(result => {
            var token = result;
            const obj = {
                "command": "exclusion",
                // "parameter": "exclusion"
                };
            const method = "PUT";
            const body = JSON.stringify(obj);
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':token
            };
            const gwInfoUpdateUrl = API_GATEWAY + "/console/v1/devices/gws/"+location.state.gwID;
            fetch(gwInfoUpdateUrl,
            {method:method, headers:headers, body:body})
            .then((res)=> res.json())
            .then(data => {
                console.log("エクスクルージョンのfetch実行完了")
                // 制御結果取得
                getControlResults(token, data["control_id"])
                .then(controlResult => {
                    if(controlResult == "success"){
                        alert("エクスクルージョンに成功しました。")
                    }else{
                        console.error("結果取得失敗"+controlResult)
                        alert("エクスクルージョンに失敗しました。")
                    }
                },[])

            },[])
                .catch(err => {
                    alert("エクスクルージョンに失敗しました")
                })
        }).catch(error => {
            console.error("IDトークン取得失敗")
        });
    }

    function getIsInvalid(sendFloorName, sendPlaceName){
        const reg_emoji = /\u{1F3F4}\u{E0067}\u{E0062}(?:\u{E0077}\u{E006C}\u{E0073}|\u{E0073}\u{E0063}\u{E0074}|\u{E0065}\u{E006E}\u{E0067})\u{E007F}|\u{1F469}\u200D\u{1F469}\u200D(?:\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}])|\u{1F468}(?:\u{1F3FF}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}-\u{1F3FE}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FE}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}-\u{1F3FD}\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FD}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}\u{1F3FC}\u{1F3FE}\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FC}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FB}\u{1F3FD}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FB}\u200D(?:\u{1F91D}\u200D\u{1F468}[\u{1F3FC}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u200D(?:\u2764\uFE0F\u200D(?:\u{1F48B}\u200D)?\u{1F468}|[\u{1F468}\u{1F469}]\u200D(?:\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}])|\u{1F466}\u200D\u{1F466}|\u{1F467}\u200D[\u{1F466}\u{1F467}]|[\u{1F468}\u{1F469}]\u200D[\u{1F466}\u{1F467}]|[\u2695\u2696\u2708]\uFE0F|[\u{1F466}\u{1F467}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|(?:\u{1F3FF}\u200D[\u2695\u2696\u2708]|\u{1F3FE}\u200D[\u2695\u2696\u2708]|\u{1F3FD}\u200D[\u2695\u2696\u2708]|\u{1F3FC}\u200D[\u2695\u2696\u2708]|\u{1F3FB}\u200D[\u2695\u2696\u2708])\uFE0F|\u{1F3FF}|\u{1F3FE}|\u{1F3FD}|\u{1F3FC}|\u{1F3FB})?|\u{1F9D1}(?:[\u{1F3FB}-\u{1F3FF}]\u200D(?:\u{1F91D}\u200D\u{1F9D1}[\u{1F3FB}-\u{1F3FF}]|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F384}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u200D(?:\u{1F91D}\u200D\u{1F9D1}|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F384}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]))|\u{1F469}(?:\u200D(?:\u2764\uFE0F\u200D(?:\u{1F48B}\u200D[\u{1F468}\u{1F469}]|[\u{1F468}\u{1F469}])|[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F3FF}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FE}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FD}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FC}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}]|\u{1F3FB}\u200D[\u{1F33E}\u{1F373}\u{1F37C}\u{1F393}\u{1F3A4}\u{1F3A8}\u{1F3EB}\u{1F3ED}\u{1F4BB}\u{1F4BC}\u{1F527}\u{1F52C}\u{1F680}\u{1F692}\u{1F9AF}-\u{1F9B3}\u{1F9BC}\u{1F9BD}])|\u{1F469}\u{1F3FF}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}-\u{1F3FE}]|\u{1F469}\u{1F3FE}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}-\u{1F3FD}\u{1F3FF}]|\u{1F469}\u{1F3FD}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}\u{1F3FC}\u{1F3FE}\u{1F3FF}]|\u{1F469}\u{1F3FC}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FB}\u{1F3FD}-\u{1F3FF}]|\u{1F469}\u{1F3FB}\u200D\u{1F91D}\u200D[\u{1F468}\u{1F469}][\u{1F3FC}-\u{1F3FF}]|\u{1F469}\u200D\u{1F466}\u200D\u{1F466}|\u{1F469}\u200D\u{1F469}\u200D[\u{1F466}\u{1F467}]|(?:\u{1F441}\uFE0F\u200D\u{1F5E8}|\u{1F469}(?:\u{1F3FF}\u200D[\u2695\u2696\u2708]|\u{1F3FE}\u200D[\u2695\u2696\u2708]|\u{1F3FD}\u200D[\u2695\u2696\u2708]|\u{1F3FC}\u200D[\u2695\u2696\u2708]|\u{1F3FB}\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\u{1F3F3}\uFE0F\u200D\u26A7|\u{1F9D1}(?:[\u{1F3FB}-\u{1F3FF}]\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\u{1F43B}\u200D\u2744|(?:[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}][\u{1F3FB}-\u{1F3FF}]|[\u{1F46F}\u{1F93C}\u{1F9DE}\u{1F9DF}])\u200D[\u2640\u2642]|[\u26F9\u{1F3CB}\u{1F3CC}\u{1F575}][\uFE0F\u{1F3FB}-\u{1F3FF}]\u200D[\u2640\u2642]|\u{1F3F4}\u200D\u2620|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}]\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u2764\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299\u{1F170}\u{1F171}\u{1F17E}\u{1F17F}\u{1F202}\u{1F237}\u{1F321}\u{1F324}-\u{1F32C}\u{1F336}\u{1F37D}\u{1F396}\u{1F397}\u{1F399}-\u{1F39B}\u{1F39E}\u{1F39F}\u{1F3CD}\u{1F3CE}\u{1F3D4}-\u{1F3DF}\u{1F3F5}\u{1F3F7}\u{1F43F}\u{1F4FD}\u{1F549}\u{1F54A}\u{1F56F}\u{1F570}\u{1F573}\u{1F576}-\u{1F579}\u{1F587}\u{1F58A}-\u{1F58D}\u{1F5A5}\u{1F5A8}\u{1F5B1}\u{1F5B2}\u{1F5BC}\u{1F5C2}-\u{1F5C4}\u{1F5D1}-\u{1F5D3}\u{1F5DC}-\u{1F5DE}\u{1F5E1}\u{1F5E3}\u{1F5E8}\u{1F5EF}\u{1F5F3}\u{1F5FA}\u{1F6CB}\u{1F6CD}-\u{1F6CF}\u{1F6E0}-\u{1F6E5}\u{1F6E9}\u{1F6F0}\u{1F6F3}])\uFE0F|\u{1F469}\u200D\u{1F467}\u200D[\u{1F466}\u{1F467}]|\u{1F3F3}\uFE0F\u200D\u{1F308}|\u{1F469}\u200D\u{1F467}|\u{1F469}\u200D\u{1F466}|\u{1F415}\u200D\u{1F9BA}|\u{1F469}(?:\u{1F3FF}|\u{1F3FE}|\u{1F3FD}|\u{1F3FC}|\u{1F3FB})?|\u{1F1FD}\u{1F1F0}|\u{1F1F6}\u{1F1E6}|\u{1F1F4}\u{1F1F2}|\u{1F408}\u200D\u2B1B|\u{1F441}\uFE0F|\u{1F3F3}\uFE0F|\u{1F9D1}[\u{1F3FB}-\u{1F3FF}]?|\u{1F1FF}[\u{1F1E6}\u{1F1F2}\u{1F1FC}]|\u{1F1FE}[\u{1F1EA}\u{1F1F9}]|\u{1F1FC}[\u{1F1EB}\u{1F1F8}]|\u{1F1FB}[\u{1F1E6}\u{1F1E8}\u{1F1EA}\u{1F1EC}\u{1F1EE}\u{1F1F3}\u{1F1FA}]|\u{1F1FA}[\u{1F1E6}\u{1F1EC}\u{1F1F2}\u{1F1F3}\u{1F1F8}\u{1F1FE}\u{1F1FF}]|\u{1F1F9}[\u{1F1E6}\u{1F1E8}\u{1F1E9}\u{1F1EB}-\u{1F1ED}\u{1F1EF}-\u{1F1F4}\u{1F1F7}\u{1F1F9}\u{1F1FB}\u{1F1FC}\u{1F1FF}]|\u{1F1F8}[\u{1F1E6}-\u{1F1EA}\u{1F1EC}-\u{1F1F4}\u{1F1F7}-\u{1F1F9}\u{1F1FB}\u{1F1FD}-\u{1F1FF}]|\u{1F1F7}[\u{1F1EA}\u{1F1F4}\u{1F1F8}\u{1F1FA}\u{1F1FC}]|\u{1F1F5}[\u{1F1E6}\u{1F1EA}-\u{1F1ED}\u{1F1F0}-\u{1F1F3}\u{1F1F7}-\u{1F1F9}\u{1F1FC}\u{1F1FE}]|\u{1F1F3}[\u{1F1E6}\u{1F1E8}\u{1F1EA}-\u{1F1EC}\u{1F1EE}\u{1F1F1}\u{1F1F4}\u{1F1F5}\u{1F1F7}\u{1F1FA}\u{1F1FF}]|\u{1F1F2}[\u{1F1E6}\u{1F1E8}-\u{1F1ED}\u{1F1F0}-\u{1F1FF}]|\u{1F1F1}[\u{1F1E6}-\u{1F1E8}\u{1F1EE}\u{1F1F0}\u{1F1F7}-\u{1F1FB}\u{1F1FE}]|\u{1F1F0}[\u{1F1EA}\u{1F1EC}-\u{1F1EE}\u{1F1F2}\u{1F1F3}\u{1F1F5}\u{1F1F7}\u{1F1FC}\u{1F1FE}\u{1F1FF}]|\u{1F1EF}[\u{1F1EA}\u{1F1F2}\u{1F1F4}\u{1F1F5}]|\u{1F1EE}[\u{1F1E8}-\u{1F1EA}\u{1F1F1}-\u{1F1F4}\u{1F1F6}-\u{1F1F9}]|\u{1F1ED}[\u{1F1F0}\u{1F1F2}\u{1F1F3}\u{1F1F7}\u{1F1F9}\u{1F1FA}]|\u{1F1EC}[\u{1F1E6}\u{1F1E7}\u{1F1E9}-\u{1F1EE}\u{1F1F1}-\u{1F1F3}\u{1F1F5}-\u{1F1FA}\u{1F1FC}\u{1F1FE}]|\u{1F1EB}[\u{1F1EE}-\u{1F1F0}\u{1F1F2}\u{1F1F4}\u{1F1F7}]|\u{1F1EA}[\u{1F1E6}\u{1F1E8}\u{1F1EA}\u{1F1EC}\u{1F1ED}\u{1F1F7}-\u{1F1FA}]|\u{1F1E9}[\u{1F1EA}\u{1F1EC}\u{1F1EF}\u{1F1F0}\u{1F1F2}\u{1F1F4}\u{1F1FF}]|\u{1F1E8}[\u{1F1E6}\u{1F1E8}\u{1F1E9}\u{1F1EB}-\u{1F1EE}\u{1F1F0}-\u{1F1F5}\u{1F1F7}\u{1F1FA}-\u{1F1FF}]|\u{1F1E7}[\u{1F1E6}\u{1F1E7}\u{1F1E9}-\u{1F1EF}\u{1F1F1}-\u{1F1F4}\u{1F1F6}-\u{1F1F9}\u{1F1FB}\u{1F1FC}\u{1F1FE}\u{1F1FF}]|\u{1F1E6}[\u{1F1E8}-\u{1F1EC}\u{1F1EE}\u{1F1F1}\u{1F1F2}\u{1F1F4}\u{1F1F6}-\u{1F1FA}\u{1F1FC}\u{1F1FD}\u{1F1FF}]|[#\*0-9]\uFE0F\u20E3|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}][\u{1F3FB}-\u{1F3FF}]|[\u26F9\u{1F3CB}\u{1F3CC}\u{1F575}][\uFE0F\u{1F3FB}-\u{1F3FF}]|\u{1F3F4}|[\u270A\u270B\u{1F385}\u{1F3C2}\u{1F3C7}\u{1F442}\u{1F443}\u{1F446}-\u{1F450}\u{1F466}\u{1F467}\u{1F46B}-\u{1F46D}\u{1F472}\u{1F474}-\u{1F476}\u{1F478}\u{1F47C}\u{1F483}\u{1F485}\u{1F4AA}\u{1F57A}\u{1F595}\u{1F596}\u{1F64C}\u{1F64F}\u{1F6C0}\u{1F6CC}\u{1F90C}\u{1F90F}\u{1F918}-\u{1F91C}\u{1F91E}\u{1F91F}\u{1F930}-\u{1F934}\u{1F936}\u{1F977}\u{1F9B5}\u{1F9B6}\u{1F9BB}\u{1F9D2}-\u{1F9D5}][\u{1F3FB}-\u{1F3FF}]|[\u261D\u270C\u270D\u{1F574}\u{1F590}][\uFE0F\u{1F3FB}-\u{1F3FF}]|[\u270A\u270B\u{1F385}\u{1F3C2}\u{1F3C7}\u{1F408}\u{1F415}\u{1F43B}\u{1F442}\u{1F443}\u{1F446}-\u{1F450}\u{1F466}\u{1F467}\u{1F46B}-\u{1F46D}\u{1F472}\u{1F474}-\u{1F476}\u{1F478}\u{1F47C}\u{1F483}\u{1F485}\u{1F4AA}\u{1F57A}\u{1F595}\u{1F596}\u{1F64C}\u{1F64F}\u{1F6C0}\u{1F6CC}\u{1F90C}\u{1F90F}\u{1F918}-\u{1F91C}\u{1F91E}\u{1F91F}\u{1F930}-\u{1F934}\u{1F936}\u{1F977}\u{1F9B5}\u{1F9B6}\u{1F9BB}\u{1F9D2}-\u{1F9D5}]|[\u{1F3C3}\u{1F3C4}\u{1F3CA}\u{1F46E}\u{1F470}\u{1F471}\u{1F473}\u{1F477}\u{1F481}\u{1F482}\u{1F486}\u{1F487}\u{1F645}-\u{1F647}\u{1F64B}\u{1F64D}\u{1F64E}\u{1F6A3}\u{1F6B4}-\u{1F6B6}\u{1F926}\u{1F935}\u{1F937}-\u{1F939}\u{1F93D}\u{1F93E}\u{1F9B8}\u{1F9B9}\u{1F9CD}-\u{1F9CF}\u{1F9D6}-\u{1F9DD}]|[\u{1F46F}\u{1F93C}\u{1F9DE}\u{1F9DF}]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F19A}\u{1F201}\u{1F21A}\u{1F22F}\u{1F232}-\u{1F236}\u{1F238}-\u{1F23A}\u{1F250}\u{1F251}\u{1F300}-\u{1F320}\u{1F32D}-\u{1F335}\u{1F337}-\u{1F37C}\u{1F37E}-\u{1F384}\u{1F386}-\u{1F393}\u{1F3A0}-\u{1F3C1}\u{1F3C5}\u{1F3C6}\u{1F3C8}\u{1F3C9}\u{1F3CF}-\u{1F3D3}\u{1F3E0}-\u{1F3F0}\u{1F3F8}-\u{1F407}\u{1F409}-\u{1F414}\u{1F416}-\u{1F43A}\u{1F43C}-\u{1F43E}\u{1F440}\u{1F444}\u{1F445}\u{1F451}-\u{1F465}\u{1F46A}\u{1F479}-\u{1F47B}\u{1F47D}-\u{1F480}\u{1F484}\u{1F488}-\u{1F4A9}\u{1F4AB}-\u{1F4FC}\u{1F4FF}-\u{1F53D}\u{1F54B}-\u{1F54E}\u{1F550}-\u{1F567}\u{1F5A4}\u{1F5FB}-\u{1F644}\u{1F648}-\u{1F64A}\u{1F680}-\u{1F6A2}\u{1F6A4}-\u{1F6B3}\u{1F6B7}-\u{1F6BF}\u{1F6C1}-\u{1F6C5}\u{1F6D0}-\u{1F6D2}\u{1F6D5}-\u{1F6D7}\u{1F6EB}\u{1F6EC}\u{1F6F4}-\u{1F6FC}\u{1F7E0}-\u{1F7EB}\u{1F90D}\u{1F90E}\u{1F910}-\u{1F917}\u{1F91D}\u{1F920}-\u{1F925}\u{1F927}-\u{1F92F}\u{1F93A}\u{1F93F}-\u{1F945}\u{1F947}-\u{1F976}\u{1F978}\u{1F97A}-\u{1F9B4}\u{1F9B7}\u{1F9BA}\u{1F9BC}-\u{1F9CB}\u{1F9D0}\u{1F9E0}-\u{1F9FF}\u{1FA70}-\u{1FA74}\u{1FA78}-\u{1FA7A}\u{1FA80}-\u{1FA86}\u{1FA90}-\u{1FAA8}\u{1FAB0}-\u{1FAB6}\u{1FAC0}-\u{1FAC2}\u{1FAD0}-\u{1FAD6}]/gu;

        if(!sendFloorName){
            return "設置フロアを入力してください"
        }
        if(reg_emoji.test(sendFloorName)){
            return "設置フロアに絵文字が含まれています"
        }
        if(32 < sendFloorName.length){
            return "設置フロアは最大32文字です"
        }
        if(reg_emoji.test(sendPlaceName)){
            return "設置部屋番号に絵文字が含まれています"
        }
        if(32 < sendPlaceName.length){
            return "設置部屋番号は最大32文字です"
        }
    }
    if (loading){
        return (

        <div class="center_parents">
            <table class="overall_table">
                <tr>
                    <td>
                    <div class="title_text">ゲートウェイ設定　＜{hotelName}＞</div>
                    </td>
                </tr>
            </table>

            <hr color="#00B4C6" size="6" />
            <br />
            <table class="table_border overall_table">
                <tr>
                    <td>
                        <div>
                        <img src={loadimg}/>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        );
    }
    return (
        <div>
            <div class="title_text">ゲートウェイ設定　＜{hotelName}＞</div>
            <hr color="#00B4C6" size="6" />
            <br />

            <div class="title_text">状態</div>  

            <table class="table_border">
                <tr class="tr_height_settinggateway">
                    <td class="table_border_updown_thtd_left" style={{width:"220px"}}>
                        <label class="li_left">ゲートウェイ</label>
                    </td>
                    <td colspan="2" class="table_border_updown_thtd_right">
                        　{gatewayInfo.serial_number}
                    </td>
                </tr>
                <tr class="tr_height_settinggateway">
                    <td class="table_border_updown_thtd_left">
                        <label class="li_left">フロア</label>
                    </td>
                    <td colspan="2" class="table_border_updown_thtd_right">
                        　{oldFloorName}
                    </td>
                </tr>
                <tr class="tr_height_settinggateway">
                    <td class="table_border_updown_thtd_left">
                        <label class="li_left">備考</label>
                    </td>
                    <td colspan="2" class="table_border_updown_thtd_right">
                        　{oldPlaceName}
                    </td>
                </tr>
                <tr class="tr_height_settinggateway">
                    <td class="table_border_updown_thtd_left">
                        <label class="li_left">状態</label>
                    </td>
                    <td colspan="2" class="table_border_updown_thtd_right">
                        　{gwState}
                    </td>
                </tr>
                <tr class="tr_height_settinggateway">
                    <td class="table_border_updown_thtd_left">
                        <label class="li_left">ファームウェアバージョン</label>
                    </td>
                    <td colspan="2" class="table_border_updown_thtd_right">
                        　{fwVersion}
                    </td>
                </tr>
                </table>
                <br />
                {admFlag &&
                <div class="title_text">登録/制御</div>  
                }
                {admFlag &&
                <table class="table_border">
                <tr class="tr_height_settinggateway">
                    <td class="table_border_updown_thtd_left" style={{width:"220px"}}>
                        <label class="li_left">フロア</label>
                    </td>
                    <td class="table_border_up_thtd_right" style={{width:"350px"}}>
                        <input class="textbox" type="text" value={floorName} onChange={floorHandleChange} maxLength={32}/>
                    </td>
                    <td rowspan="2" class="table_border_updown_thtd_right">
                    {admFlag &&
                        <td>
                            <button class="button" onClick={() => setRegistSend(registSend+1)}>登録</button>
                        </td>}
                    </td>
                </tr>
                <tr class="tr_height_settinggateway">
                    <td class="table_border_down_thtd_left">
                        <label class="li_left">備考</label>
                    </td>
                    <td colspan="2" class="table_border_down_thtd_right">
                        <input class="textbox" type="text" value={placeName} onChange={roomHandleChange} maxLength={32}/>
                    </td>
                </tr>
                <tr class="tr_height_settinggateway">
                    <td class="table_border_updown_thtd_left">
                        <label class="li_left">エクスクルージョン</label>
                    </td>
                    <td colspan="2" class="table_border_updown_thtd_right">
                        <td>
                            <button class="button" type="submit" value="実行" onClick={handleExclusionClick.bind(this)}>実行</button>
                        </td>
                    </td>
                </tr>
                <tr class="tr_height_settinggateway">
                    <td class="table_border_updown_thtd_left">
                        <label class="li_left">ファームウェア更新</label>
                    </td>
                    <td colspan="2" class="table_border_updown_thtd_right">
                        <td>
                            <button class="button" type="submit" value="実行" onClick={handleFwClick.bind(this)}>実行</button>
                        </td>
                    </td>
                </tr>
            </table>}

            <br />
        </div>
    );
}
 
export default Setting_gateway;
